import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { registraPermesso } from '@/lib/raccoltaPermessi'

/**
 * Custom hook to check if the current user has a specific permission
 *
 * @param permission - Permission code to check (e.g., 'customers.create', 'vehicles.delete')
 * @returns boolean - true if user has the permission, false otherwise
 *
 * @example
 * const canCreateCustomer = usePermission('customers.create')
 * const canDeleteVehicle = usePermission('vehicles.delete')
 *
 * return (
 *   <>
 *     {canCreateCustomer && <Button onClick={handleCreate}>Create</Button>}
 *     {canDeleteVehicle && <Button onClick={handleDelete}>Delete</Button>}
 *   </>
 * )
 */
export const usePermission = (permission: string): boolean => {
  // Traccia il permesso per il pannello diagnostico. Sola Set.add: non
  // cambia il valore di ritorno e non provoca render.
  registraPermesso(permission)

  const authContext = useContext(AuthContext)

  if (!authContext) {
    console.warn('usePermission must be used within AuthProvider')
    return false
  }

  const { user, permissions } = authContext

  // If user is not logged in
  if (!user || !permissions) {
    return false
  }

  // Nessuna scorciatoia per ruolo: la matrice e' l'unica fonte, ADMIN compreso.
  return permissions.includes(permission)
}
